export enum TemplateTypes {
  TICKER = "Ticker",
  OVERLAY = "Lower Left Icon + Text",
  FULLSCREEN = "Fullscreen",
}
export const getTemplateType = (templateId: string): string => {
  if (templateId == "3") {
    return TemplateTypes.TICKER;
  } else if (templateId == "2") {
    return TemplateTypes.OVERLAY;
  } else if (templateId == "1") {
    return TemplateTypes.FULLSCREEN;
  } else return "";
};
